import { useContext } from 'react';
import { ClientContext } from './Provider';

export default function useClient() {
  return useContext(ClientContext);
}
